import { useState } from 'react'
import { DateTimeFilter } from './FilterDropdown'

export default function DateTimePicker({ name, label }: { name: string; label: string }) {
  const [value, setValue] = useState('')
  return <div className="authorization-date-field">
    <input type="hidden" name={name} value={value} />
    <DateTimeFilter label={label} value={value} onChange={setValue} />
  </div>
}
